import { HelpTagDefinition } from "./interfaces";

//
// all the tags should follow the tree-like structure
// tags for the page general manual should end with ".$"
// there should be no tags without a dot in it
//
export const BASE_TAGS = [
    // ---
    // layout
    // header
    {
        tag: "header.tracker",
        name: "Tracker",
    },
    // ---
    // dashboard
    {
        tag: "dashboard.$",
        name: "Dashboard Guide",
    },
    {
        tag: "dashboard.month-overview.general",
        name: "Month overview",
    },
    {
        tag: "dashboard.hours-distribution.general",
        name: "Hours distribution",
    },
    {
        tag: "dashboard.reported-contracted.general",
        name: "Report Progress",
    },
    {
        tag: "dashboard.calendar-schedule.general",
        name: "Calendar schedule",
    },
    // ---
    // admin/time page
    {
        tag: "admin-time.$",
        name: "Time Reporting Guide",
    },
    // shared
    {
        tag: "admin-time.shared.calendar-track",
        name: "Track meeting button",
    },
    {
        tag: "admin-time.shared.report-all",
        name: "Report all button",
    },
    {
        tag: "admin-time.shared.fill-out",
        name: "Fill-out button",
    },
    {
        tag: "admin-time.shared.templates",
        name: "Report templates",
    },
    {
        tag: "admin-time.shared.project-field",
        name: "Project field",
    },
    {
        tag: "admin-time.shared.fee-category-field",
        name: "Fee category (LoB) field",
    },
    {
        tag: "admin-time.shared.fee-code-field",
        name: "Fee code field",
    },
    {
        tag: "admin-time.shared.duration-field",
        name: "Duration field",
    },
    {
        tag: "admin-time.shared.reverse-button",
        name: "Reverse button",
    },
    {
        tag: "admin-time.shared.unreport-button",
        name: "Unreport button",
    },
    // month
    {
        tag: "admin-time.month.general",
        name: "Month view",
    },
    {
        tag: "admin-time.month.cell",
        name: "Month cell",
        selectors: [
            { selector: "gray", name: "If cell has gray color" },
            { selector: "red", name: "If cell has red color" },
            { selector: "green", name: "If cell has green color" },
            { selector: "yellow", name: "If cell has yellow color" },
            {
                selector: "striped",
                name: "If cell striped (green color with dot)",
            },
        ],
    },
    {
        tag: "admin-time.month.contracts",
        name: "Contracted, tracked and reported hours",
    },
    {
        tag: "admin-time.month.day-status-selector",
        name: "Day status",
    },
    {
        tag: "admin-time.month.add-activity",
        name: "Add activity button",
    },
    // week
    {
        tag: "admin-time.week.general",
        name: "Week view",
    },
    {
        tag: "admin-time.week.slot",
        name: "Slot functions",
    },
    // week-day
    {
        tag: "admin-time.week-day.scale-range",
        name: "Scale range",
    },
    {
        tag: "admin-time.week-day.add-activity",
        name: "Add activity button",
    },
    // day
    {
        tag: "admin-time.day.general",
        name: "Day view",
    },
    {
        tag: "admin-time.day.column-all",
        name: "Column 'All'",
    },
    {
        tag: "admin-time.day.column-task",
        name: "Column 'Task'",
    },
    {
        tag: "admin-time.day.column-timer",
        name: "Column 'Timer'",
    },
    {
        tag: "admin-time.day.column-calendar",
        name: "Column 'Calendar'",
    },
    {
        tag: "admin-time.day.column-custom",
        name: "Column 'Custom'",
    },
    {
        tag: "admin-time.day.reported-contracted",
        name: "Reported/Contracted",
    },
    // panel
    {
        tag: "admin-time.panel.connect-outlook",
        name: "Connect Outlook button",
    },
    {
        tag: "admin-time.panel.filter-calendars",
        name: "Calendars filter",
    },
    {
        tag: "admin-time.panel.types",
        name: "Types filter",
    },
    {
        tag: "admin-time.panel.statuses",
        name: "Statuses filter",
    },
    {
        tag: "admin-time.panel.mode-month",
        name: "Month mode",
    },
    {
        tag: "admin-time.panel.mode-week",
        name: "Week mode",
    },
    {
        tag: "admin-time.panel.mode-day",
        name: "Day mode",
    },
    // ---
    // admin/expenses page
    {
        tag: "admin-expenses.$",
        name: "Expenses Guide",
    },
    {
        tag: "admin-expenses.expense.actions",
        name: "Expense actions",
    },
    {
        tag: "admin-expenses.expense.submit",
        name: "Submit expense button",
    },
    {
        tag: "admin-expenses.expense.status",
        name: "Expense status",
        selectors: [
            { selector: "submitted", name: "Submitted" },
            { selector: "not_submitted", name: "Not Submitted" },
            { selector: "not_submitted_ready", name: "Not Submitted Ready" },
            { selector: "approved", name: "Approved" },
            { selector: "booked_unpaid", name: "Booked Not Paid" },
            { selector: "booked_paid", name: "Booked Paid" },
            { selector: "deleted", name: "Deleted" },
        ],
    },
    {
        tag: "admin-expenses.receipt.status",
        name: "Receipt status",
        selectors: [
            { selector: "incomplete", name: "Incomplete" },
            { selector: "needs_review", name: "Needs Review" },
            { selector: "ready", name: "Ready" },
        ],
    },
    {
        tag: "admin-expenses.expense.add",
        name: "Add expense form",
    },
    {
        tag: "admin-expenses.expense.remove",
        name: "Remove expenses button",
    },
    {
        tag: "admin-expenses.panel.statuses",
        name: "Statuses filter",
    },
    {
        tag: "admin-expenses.panel.search",
        name: "Search expenses",
    },
    {
        tag: "admin-expenses.receipt.date",
        name: "Date field",
    },
    {
        tag: "admin-expenses.receipt.type",
        name: "Expense type field",
    },
    {
        tag: "admin-expenses.receipt.project",
        name: "Project field",
    },
    {
        tag: "admin-expenses.receipt.purchase-code",
        name: "Purchase code field",
    },
    {
        tag: "admin-expenses.receipt.currency",
        name: "Currency field",
    },
    {
        tag: "admin-expenses.receipt.description",
        name: "Description field",
    },
    {
        tag: "admin-expenses.receipt.amount",
        name: "Amount field",
    },
    {
        tag: "admin-expenses.receipt.quantity",
        name: "Quantity field",
    },
    {
        tag: "admin-expenses.receipt.base-vat",
        name: "Base VAT field",
    },
    // ---
    // admin/approval page
    {
        tag: "admin-approval.$",
        name: "Approval Guide",
    },
    {
        tag: "admin-approval.receipt.status",
        name: "Receipt warnings",
    },
    {
        tag: "admin-approval.entity.approve-form",
        name: "Approve form",
    },
    {
        tag: "admin-approval.entity.approve-button",
        name: "Approve button",
        selectors: [
            { selector: "final", name: "Final approval button" },
            { selector: "pre", name: "Pre-approval button" },
        ],
    },
    {
        tag: "admin-approval.entity.posting-button",
        name: "Posting button",
    },
    {
        tag: "admin-approval.panel.statuses",
        name: "Statuses filter",
    },
    {
        tag: "admin-approval.purchase.purchase-order",
        name: "Purchase order field",
    },
    {
        tag: "admin-approval.purchase.client",
        name: "Client field",
    },
    {
        tag: "admin-approval.purchase.project",
        name: "Project field",
    },
    {
        tag: "admin-approval.purchase.purchase-code",
        name: "Purchase code field",
    },
    {
        tag: "admin-approval.purchase.vat-class",
        name: "VAT class field",
    },
    {
        tag: "admin-approval.purchase.purchase-price",
        name: "Purchase price field",
    },
    {
        tag: "admin-approval.purchase.markup",
        name: "Markup field",
    },
    {
        tag: "admin-approval.purchase.sales-price",
        name: "Sales price field",
    },
    {
        tag: "admin-approval.purchase.comment",
        name: "Comment field",
    },
    {
        tag: "admin-approval.purchase.purchase-price-in-base",
        name: "Purchase price in base currency field",
    },
    // ---
    // profile page
    {
        tag: "profile.$",
        name: "Profile Guide",
    },
    // general
    {
        tag: "profile.outlook.not-connected",
        name: "Outlook account is not connected",
    },
    {
        tag: "profile.outlook.calendar",
        name: "Calendar option in the Outlook account",
    },
    {
        tag: "profile.recurring-events.header",
        name: "Recurring events",
    },
    {
        tag: "profile.custom-activities.header",
        name: "Custom Activities",
    },
    {
        tag: "profile.custom-activities.use-start",
        name: "Use start & end time for custom activities",
    },
    {
        tag: "profile.expenses.ocr-description",
        name: "Use receipt category as description",
    },
    {
        tag: "profile.tracks.import-template",
        name: "Import template button",
    },
    {
        tag: "profile.tracks.add-activity",
        name: "Add new activity button",
    },
    {
        tag: "profile.tracks.filter",
        name: "Filter tracks by active/archived",
    },
    {
        tag: "profile.tracks.archive",
        name: "Archive track button",
    },
    {
        tag: "profile.tracks.remove",
        name: "Remove track button",
    },
    {
        tag: "profile.tracks.template",
        name: "Template button for track",
    },
    {
        tag: "profile.tracks.fill-out",
        name: "Fill out button for track",
    },
] as const satisfies HelpTagDefinition[];

//
// every tag has a fallback tag, which is used when the tag is not found
// it should be the same tag with a question mark at the end
//
export const TAGS = BASE_TAGS.flatMap((tag) => [
    tag,
    {
        tag: `${tag.tag}?` as const,
        name: `Fallback for "${tag.name}"`,
        selectors: [],
    },
]);

export type HelpTag = (typeof TAGS)[number]["tag"];

type Selectors<T extends (typeof TAGS)[number]> = T extends {
    selectors: infer S;
}
    ? S
    : never;

type HelpTagToSelectors<
    Tag extends string,
    T extends (typeof TAGS)[number] = (typeof TAGS)[number],
> = T extends { tag: Tag } ? "$" | Selectors<T>[number]["selector"] : never;

export type HelpSelector<Tag extends HelpTag> = HelpTagToSelectors<Tag>;
